import styled from 'styled-components';
import { color } from 'styles/colors';

export const inputImg = styled.div`
  position: relative;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  > p {
    font-weight: 700;
    color: ${color.interface.lightGray};
    font-size: 1.4rem;
  }

  > input {
    display: none;
  }
`;

interface LabelWithImageProps {
  isActive: boolean;
}

export const labelWithImage: any = styled.div<LabelWithImageProps>`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    > label {
      min-height: 40px;
      max-height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${color.interface.lightGray};
      width: fit-content;
      cursor: ${props => (props.isActive ? 'pointer' : 'not-allowed')};
      padding: 0.5rem 1rem 0.5rem 1rem;
      border-radius: 5px;
      border: 1px solid ${color.interface.lightGray2};
    }

    > svg {
      cursor: pointer;
      font-size: 30px;
      border-radius: 5px;
      color: ${color.interface.red};
    }
  }

  > svg {
    font-size: 100px;
    border-radius: 5px;
  }
`;

export const img = styled.div`
  background-color: ${color.interface.lightGray2};
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  > img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
`;
